import { createContext } from 'react';

import { PathwayActivityImage } from '@/components/patients/addPatient/AssignFirstActivities/PathwayImage';
import { PathwayAndActivityType, RecommendedFrequency } from '@/hooks/api/activities/types';
import { Picture } from '@/hooks/api/types';

export interface ActivityCart {
  activityCart: Array<ActivityCartItem>;
  toggleActivityCartItem: (item: ActivityCartItem) => void;
  onReset: () => void;
}

export interface ActivityCartItem {
  id: string;
  activityType: PathwayAndActivityType;
  title?: string;
  image?: Picture;
  images?: Array<PathwayActivityImage>;
  isSituationalJournal?: boolean;
  recommendedFrequency?: RecommendedFrequency;
}

const ActivityCartContext = createContext<ActivityCart>({
  activityCart: [],
  toggleActivityCartItem: (_item: ActivityCartItem) => void {},
  onReset: () => void {},
});

export default ActivityCartContext;
